import {
    AnnualReportStep,
    AnnualReportTemplateConsistency,
    AnnualReportTemplateState,
} from '@modeso/types__aumico-lib-annualreport-be';
import { IDynamicKeyValue } from '@modeso/types__aumico-lib-core-be';
import { AnnualReportBusinessModel } from '../enums/annual-report-business-model.enum';
import { IAnnualReportTemplateSettings } from './annual-report-template-settings.interface';

export interface IAnnualReportTemplateDTO {
    readonly id?: string;
    name: string;
    caption: IDynamicKeyValue;
    annualReportSteps: AnnualReportStep[];
    balanceTaxonomyId?: string | null;
    incomeTaxonomyId?: string | null;
    notesTemplateId?: string | null;
    reportingTemplateId?: string | null;
    reportingTemplateName?: string | null;
    legalFormsIds: string[];
    accountingBasesIds: string[];
    countryISO31661Alpha2Codes: string[];
    state: AnnualReportTemplateState;
    consistency: AnnualReportTemplateConsistency;
    businessModel: AnnualReportBusinessModel;
    settings?: IAnnualReportTemplateSettings | null;
    locales: string[];
}
